<template>
  <div class="scaling-background">
    <svg class="scaling-background__svg" :viewBox="smallViewBox" width="100%" v-if="mediaSmall" />
    <svg class="scaling-background__svg" :viewBox="largeViewBox" width="100%" v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'scaling-background',
  props: {
    largeHeight: { type: Number, default: 2000 },
    smallHeight: { type: Number, default: 984 },

    largeWidth: { type: Number, default: 3100 },
    smallWidth: { type: Number, default: 600 },

  },
  computed: {
    smallViewBox() {
      return `0 0 ${this.smallWidth} ${this.smallHeight}`;
    },
    largeViewBox() {
      return `0 0 ${this.largeWidth} ${this.largeHeight}`;
    },
    ...mapState('windowMedia', [
      'mediaSmall'
    ]),
  },
};
</script>

<style lang="scss">
.scaling-background {
  position: absolute;
  z-index: $z-index-background;
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  &,
  & > &__svg {
    pointer-events: none;
  }
}

</style>
